import { X } from "lucide-react";

// Varianta A — chips-uri removabile pentru filtrele avansate active.
// Afișate permanent lângă butonul "Filtre avansate" (colapsat implicit).
const LABELS = {
  status: "Status intern",
  business_status: "Status business",
  supplier: "Furnizor",
  source_system: "Sursă",
  customer_type: "Tip client",
  agency_id: "Agenție",
  agent_id: "Agent",
  product_id: "Tip produs",
  offer_id: "Ofertă",
  signed_date_from: "Semnat de la",
  signed_date_to: "Semnat până la",
  needs_reconciliation: "Reconciliere",
  unassigned_only: "Neasociate",
  activation_days_min: "În Activare ≥ zile",
  supplier_status: "Status furnizor (PPC)",
  supplier_ok: "Furnizor OK",
  csd_date_from: "CSD de la",
  csd_date_to: "CSD până la",
  document_validation_date_from: "Doc. validare de la",
  document_validation_date_to: "Doc. validare până la",
  request_confirmed_from: "CSD SF de la",
  request_confirmed_to: "CSD SF până la",
  sf_last_modified_by: "Modificat de (SF)",
  requires_rework: "Rework",
  problem_reason_code: "Cod problemă",
  returned: "Returnate",
  commissioned: "Comisionate",
  sf_contract_state: "Stare SF",
  registration_type: "Tip proces",
  commissionable: "Comisionabilitate",
  incomplete: "Incomplete",
  general_status: "Status general",
  general_status_rule_code: "Regulă status",
  has_conflict: "Conflict",
  has_blocking_conflict: "Conflict blocant",
  is_stale: "Status neactualizat",
};

const SKIP_KEYS = new Set(["sort_by", "sort_dir", "preset"]);

const formatValue = (key, value, lookups) => {
  if (value === "true" || value === true) return "Da";
  if (value === "false" || value === false) return "Nu";
  const byId = (list) => (list || []).find((x) => x.id === value)?.name;
  if (key === "agency_id") return byId(lookups.agencies) || value;
  if (key === "product_id") return byId(lookups.products) || value;
  if (key === "offer_id") return byId(lookups.offers) || value;
  return String(value);
};

export const ActiveFilterChips = ({ filters, onChange, lookups = {} }) => {
  const chips = [];
  Object.entries(filters || {}).forEach(([key, value]) => {
    if (SKIP_KEYS.has(key)) return;
    if (key === "general_status" && Array.isArray(value)) {
      value.forEach((item) => {
        if (!item) return;
        chips.push({
          id: `general_status:${item}`,
          label: LABELS.general_status,
          display: item,
          remove: () => onChange({ ...filters, general_status: value.filter((v) => v !== item) }),
        });
      });
      return;
    }
    if (value === "" || value === null || value === undefined) return;
    if (Array.isArray(value) && value.length === 0) return;
    chips.push({
      id: key,
      label: LABELS[key] || key,
      display: formatValue(key, value, lookups),
      remove: () => onChange({ ...filters, [key]: "" }),
    });
  });

  if (chips.length === 0) return null;

  return (
    <div className="flex flex-wrap items-center gap-1.5" data-testid="active-filter-chips">
      {chips.map((chip) => (
        <span
          key={chip.id}
          className="inline-flex items-center gap-1 rounded-full border border-blue-200 bg-blue-50 pl-2.5 pr-1 py-0.5 text-xs text-blue-800"
          data-testid={`filter-chip-${chip.id.replace(":", "-")}`}
        >
          <span className="text-blue-500">{chip.label}:</span>
          <span className="font-medium max-w-[180px] truncate">{chip.display}</span>
          <button
            type="button"
            onClick={chip.remove}
            className="rounded-full p-0.5 hover:bg-blue-100 hover:text-blue-950"
            aria-label={`Elimină filtrul ${chip.label}`}
            data-testid={`remove-chip-${chip.id.replace(":", "-")}`}
          >
            <X className="h-3 w-3" />
          </button>
        </span>
      ))}
    </div>
  );
};

export default ActiveFilterChips;
